/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import ContactUs from './ContactUs';
import NavigationActions from '../redux/NavigationActions';

function mapStateToProps(state, routerProps) {
  return {
    goBack: () => {
      NavigationActions.goBack(routerProps.history);
    },
  };
}

export default connect(mapStateToProps)(ContactUs);
